import { constantsActive } from 'utils/constants/constants'

export default class ObjectBuildingContact {
	
	static defaults = {
		active: constantsActive.YES,
	}
}
